import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["publisher", "year", "title", "date", "pubDateTo", "keyword"];

  connect() {
    const keyword = localStorage.getItem("deed_search.keyword");
    const publisher = localStorage.getItem("deed_search.publisher");
    const year = localStorage.getItem("deed_search.year");
    const title = localStorage.getItem("deed_search.title");
    const date = localStorage.getItem("deed_search.date");
    const pubDateTo = localStorage.getItem("deed_search.pubDateTo");

    if (keyword) {
      this.keywordTarget.value = JSON.parse(keyword);
    }

    if (publisher) this.publisherTarget.value = publisher;
    if (year) this.yearTarget.value = year;
    if (title) this.titleTarget.value = title;
    if (date) this.dateTarget.value = date;
    if (pubDateTo) this.pubDateToTarget.value = pubDateTo;
  }

  save() {
    let keyword = this.keywordTarget.value;

    if (keyword.length > 0) {
      localStorage.setItem("deed_search.keyword", JSON.stringify(keyword));
    }
    localStorage.setItem("deed_search.publisher", this.publisherTarget.value);
    localStorage.setItem("deed_search.year", this.yearTarget.value);
    localStorage.setItem("deed_search.title", this.titleTarget.value);
    localStorage.setItem("deed_search.date", this.dateTarget.value);
    localStorage.setItem("deed_search.pubDateTo", this.pubDateToTarget.value);
  }

  reset() {
    localStorage.removeItem("deed_search.keyword");
    localStorage.removeItem("deed_search.publisher");
    localStorage.removeItem("deed_search.year");
    localStorage.removeItem("deed_search.title");
    localStorage.removeItem("deed_search.date");
    localStorage.removeItem("deed_search.pubDateTo");
  }
}
